import React from 'react';
import { PencilIcon } from 'lucide-react';
import type { House } from '../../types/house';
import { HOUSE_TYPE_LABELS, LABEL_COLORS, formatPostcode } from '../../utils/house';
import { num } from '../../utils/format';
interface HouseCardProps {
  house: House;
  onEdit: () => void;
}
export function HouseCard({
  house,
  onEdit
}: HouseCardProps) {
  return <div className="rounded-2xl bg-canvas p-4 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.55)] sm:p-5" data-id="element-417" data-mp="1uata6r0nqzvz">
      <div className="flex items-start justify-between gap-4" data-id="element-418" data-mp="2r12haxfx5dvv">
        <div className="min-w-0" data-id="element-419" data-mp="2n2wg04xunqic">
          <div className="flex items-center gap-2 text-[12px] font-medium text-ink-muted" data-id="element-420" data-mp="2mzgx0r121xbn">
            <span className={`h-1.5 w-1.5 rounded-full ${house.source === 'bag' ? 'bg-forest-light' : 'bg-sun'}`} data-id="element-421" data-mp="2i4l6jvbgvi0n" />
            {house.source === 'bag' ? 'Gegevens uit de BAG' : 'Voorbeeldwoning · demo-data'}
          </div>
          <h2 className="mt-1 truncate text-lg font-semibold text-ink" data-id="element-422" data-mp="11o8jlss0arth">
            {house.street} {house.houseNumber}
          </h2>
          <p className="text-[14px] text-ink-muted" data-id="element-423" data-mp="2favkvahh2vvi">
            {formatPostcode(house.postcode)} {house.city}
          </p>
        </div>
        <button type="button" onClick={onEdit} className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line text-ink transition-colors duration-150 hover:bg-canvas-deep" aria-label="Ander adres invoeren" data-id="element-424" data-mp="2jamgbrhy206d">
          <PencilIcon className="h-4 w-4" data-id="element-425" data-mp="1vkjv9vcg5uh9" />
        </button>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2 text-[13px]" data-id="element-426" data-mp="20dl9s28qrs0b">
        <span className="inline-flex h-7 min-w-[44px] items-center justify-center rounded-md px-2 font-semibold text-white" style={{
        backgroundColor: LABEL_COLORS[house.energyLabel]
      }} title="Indicatief energielabel" data-id="element-427" data-mp="1mlon4dpueabb">
          {house.energyLabel}
        </span>
        <span className="rounded-md bg-canvas-deep px-2.5 py-1 text-ink-soft" data-id="element-428" data-mp="1hmlg4nqaxu0p">{HOUSE_TYPE_LABELS[house.houseType]}</span>
        <span className="rounded-md bg-canvas-deep px-2.5 py-1 text-ink-soft" data-id="element-429" data-mp="yii8m09walh1">{num(house.livingArea)} m²</span>
        <span className="rounded-md bg-canvas-deep px-2.5 py-1 text-ink-soft" data-id="element-430" data-mp="tp5nw18c6ytk">Bouwjaar {house.buildYear}</span>
      </div>
    </div>;
}